import { Form, Input, Modal } from "antd";
import { formatCurrency } from "../../../../../utils/formatCurrency";
import { getMinStayForDate } from "../../../../../utils/getMinStayForDate";
import { getMaxStayForDate } from "../../../../../utils/getMaxStayForDate";

export const ManualUpdateRoomModal = (props) => {
  const {
    selectedType,
    manualRate,
    selectedDate,
    modalVisible,
    selectedRatePlanId,
    availableRooms,
    ratePlans,
    selectedRoomId,
    minimumStay,
    maximumStay,
    handleModalOk,
    handleModalCancel,
    handleAvailabilityChange,
    handleManualRateChange,
    handleMinimumStayChange,
    handleMaximumStayChange,
  } = props;
  const minStayArray =
    minimumStay[selectedRoomId]?.[selectedDate.format("DD-MM-YYYY")] || [];
  const minStayForDate = getMinStayForDate({
    minimumStays: minStayArray,
    selectedRatePlanId: selectedRatePlanId,
  });
  const maxStayArray =
    maximumStay[selectedRoomId]?.[selectedDate.format("DD-MM-YYYY")] || [];
  const maxStayForDate = getMaxStayForDate({
    maximumStays: maxStayArray,
    selectedRatePlanId: selectedRatePlanId,
  });

  return (
    <Modal
      title={`YOUR ACTION ON ${selectedDate.format("DD-MM-YYYY")}`}
      visible={modalVisible}
      onOk={handleModalOk}
      onCancel={handleModalCancel}
    >
      {selectedType === "maximumStay" || selectedType === "minimumStay" ? (
        <Form layout="vertical">
          <Form.Item label="Minimum Stay">
            <Input
              type="number"
              value={minStayForDate || ""}
              onChange={handleMinimumStayChange}
              placeholder="Enter minimum stay (optional)"
            />
          </Form.Item>

          <Form.Item label="Maximum Stay">
            <Input
              type="number"
              value={maxStayForDate || ""}
              onChange={handleMaximumStayChange}
              placeholder="Enter maximum stay (optional)"
            />
          </Form.Item>
        </Form>
      ) : (
        <Form layout="vertical">
          {!selectedRatePlanId && (
            <Form.Item label="Available Rooms">
              <Input
                type="number"
                value={availableRooms}
                onChange={handleAvailabilityChange}
                placeholder="Enter available rooms (optional)"
              />
            </Form.Item>
          )}

          <Form.Item
            label={
              selectedRatePlanId ? "Rate for the Selected Date" : "Rent Per Day"
            }
          >
            <Input
              type="text"
              value={
                manualRate
                  ? formatCurrency(
                      Number(manualRate.toString().replace(/\./g, ""))
                    )
                  : ""
              }
              onChange={handleManualRateChange}
              disabled={
                selectedRatePlanId &&
                ratePlans[selectedRoomId]?.find(
                  (plan) => plan._id === selectedRatePlanId
                )?.ratePlanSetup !== "Manual"
              }
              placeholder="Enter rate (optional)"
            />
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};
